const HeaderMobileButton = () => {
  return (
    <button
      type="button"
      className="middle-iconfixed position-fixed top-50 start-0 left-nav-icon"
    >
      <i className="ti ti-adjustments-horizontal n8-color d-block d-lg-none fs-two">
        menu
      </i>
    </button>
  );
};

export default HeaderMobileButton;
